import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import styles from './DrawerInfoGrid.module.scss'

const DrawerInfoGrid = ({
  children,
  columns = 2,
  className = ''
}) => {
  return (
    <Box
      className={`${styles.detailsGrid} ${className}`}
      style={columns !== 2 ? { gridTemplateColumns: `repeat(${columns}, 1fr)` } : undefined}
    >
      {children}
    </Box>
  )
}

DrawerInfoGrid.propTypes = {
  children: PropTypes.node.isRequired,
  columns: PropTypes.number,
  className: PropTypes.string
}

export default DrawerInfoGrid
